import {appFetch, AppFetchResponse} from "../utils/appFetch";
import {ConsentIntegrationOptions} from "../components/consentIntegrationSection/ConsentIntegrationSection";

export const setIntegrationKey = async (domain: string, integration: ConsentIntegrationOptions, key: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `shop/integration-key/${integration}`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { key },
        domain,
        isEncrypted: true,
    });
}